import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import moment from 'moment';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Grid,
  Container,
  Typography,
  Stack,
  Select,
  OutlinedInput,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  FormControl,
  Modal,
  Box,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
// components
import { Print } from '@mui/icons-material';
// sections
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { StatusList } from 'src/types/statusTypes';
import Services from 'src/services/Services';
import './postdetailpage.scss';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import api from 'src/services/BaseService';
import { saveAs } from 'file-saver';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  ImageRun,
  AlignmentType,
  BorderStyle,
} from 'docx';
import Iconify from 'src/components/iconify';

const epLogo = `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`;

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const readyList = [
  'Gönderi teslim alınamıyor',
  'Gönderi teslim edilemiyor',
  'Teknik sorun',
  'Diğer',
];

export default function PostDetailPage() {
  const theme = useTheme();
  const customer = useSelector((state) => state.customerReducer);
  const [user, setUser] = useState();
  const [token, setToken] = useState('');
  const [barcode, setBarcode] = useState('');
  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [deliveryCode, setDeliveryCode] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [showSupportDialog, setShowSupportDialog] = useState(false);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showTCDialog, setShowTCDialog] = useState(false);
  const [showManualDialog, setShowManualDialog] = useState(false);
  const [supportTitle, setSupportTitle] = useState('');
  const [supportReadyDescription, setSupportReadyDescription] = useState('');
  const [supportDescription, setSupportDescription] = useState('');
  const [processResult, setProcessResult] = useState('');
  const [otp, setOtp] = useState('');
  const [tc, setTc] = useState('');
  const [invoice, setInvoice] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [logs, setLogs] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);
  const [showLogDialog, setShowLogDialog] = useState(false);
  const [permission, setPermission] = useState(false);
  const [modalAction, setModalAction] = useState('');
  const [openArasKargoModal, setOpenArasKargoModal] = useState(false);
  const [openSetInBranchModal, setOpenSetInBranchModal] = useState(false);

  const [arasKargoDeliverName, setArasKargoDeliverName] = useState('');
  const [arasKargoDeliverLastname, setArasKargoDeliverLastname] = useState('');
  const [arasKargoDeliverOTP, setArasKargoDeliverOTP] = useState('');

  const [hepsijetDeliverName, setHepsijetDeliverName] = useState('');
  const [hepsijetDeliverLastname, setHepsijetDeliverLastname] = useState('');

  const [eCommerceCompany, setECommerceCompany] = useState('');

  const parsedUser = JSON.parse(localStorage.getItem('user'));

  const { id } = useParams();

  function maskName(name) {
    if (!name) return '';

    const parts = name.split(' ');

    const maskedParts = parts.map((part) => {
      if (part.length <= 2) {
        return part;
      }
      const firstTwoLetters = part.substring(0, 2);
      const remaining = '*'.repeat(part.length - 2);
      return firstTwoLetters + remaining;
    });

    const maskedName = maskedParts.join(' ');

    return maskedName;
  }

  function splitName(fullName) {
    const nameParts = fullName.trim().split(' ');

    if (nameParts.length === 1) {
      return { name: nameParts[0], lastname: '' };
    }

    const lastname = nameParts.pop();
    const name = nameParts.join(' ');

    return { name, lastname };
  }

  const dhlCustomerRefuse = () => {
    Services.DHLCustomerRefuse(token, data.barcode)
      .then((res) => {
        console.log("DHL Customer Refuse:",res.data)
        if (res.data.status) {
          setProcessResult('success');
          setShowResultModal(true);
        } else {
          setProcessResult('fail');
          setShowResultModal(true);
        }
      })
      .catch((err) => {
        setProcessResult('fail');
        setShowResultModal(true);
      })
      .finally(() => {
        setShowModal(false);
        setLoading(false);
      });
  }

  function exportToWord() {
    const doc = new Document({
      sections: [
        {
          children: [
            // Logo at the top, centered
            new Paragraph({
              children: [
                new ImageRun({
                  data: epLogo,
                  transformation: {
                    width: 100, // Adjust width as needed
                    height: 100, // Adjust height as needed
                  },
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
            // Spacer after the logo
            new Paragraph({
              children: [new TextRun({ text: '', break: 1 })],
            }),
            // Paket Barkodu
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Paket Barkodu: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: data.barcode ? data.barcode : '-',
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Alıcı Adı
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Alıcı Adı: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: data.willTakenBy ? data.willTakenBy : '-',
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Teslim Edilecek İl/İlçe
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Teslim Edilecek İl/İlçe: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: `${data.sentToCity}/${data.sentToRegion}`,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Teslim Edilecek Easy Point Noktası
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Teslim Edilecek Easy Point Noktası: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: data.pointTitle ? data.pointTitle : '-',
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Kargo Firması
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Kargo Firması: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: data.shipmentFirm ? data.shipmentFirm : '-',
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Kargo Takip No
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Kargo Takip No: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: data.shipmentNo ? data.shipmentNo : '-',
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Gönderi Tarihi
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Gönderi Tarihi: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: formatDate(data.createdDateTime),
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Gönderi Durumu
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Gönderi Durumu: ',
                  bold: true,
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
                new TextRun({
                  text: getStatusLabel(data.status),
                  font: {
                    name: 'Trebuchet MS',
                  },
                }),
              ],
            }),
            // Separator
            new Paragraph({
              children: [new TextRun({ text: '', break: 1 })],
            }),
            ...logs
              .map((log, index) => [
                // Separator above the log
                new Paragraph({
                  border: {
                    top: {
                      size: 1,
                      color: 'auto',
                      space: 1,
                      style: BorderStyle.SINGLE,
                    },
                  },
                }),
                // Log Tarihi
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Log Tarihi: ',
                      bold: true,
                      font: {
                        name: 'Trebuchet MS',
                      },
                    }),
                    new TextRun({
                      text: formatDate(log.created_date_time),
                      font: {
                        name: 'Trebuchet MS',
                      },
                    }),
                  ],
                }),
                // Log
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Log: ',
                      bold: true,
                      font: {
                        name: 'Trebuchet MS',
                      },
                    }),
                    new TextRun({
                      text: log.view.message ? log.view.message : log.view,
                      font: {
                        name: 'Trebuchet MS',
                      },
                    }),
                  ],
                }),
                // Kullanıcı Tipi
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Kullanıcı Tipi: ',
                      bold: true,
                      font: {
                        name: 'Trebuchet MS',
                      },
                    }),
                    new TextRun({
                      text: log.user_type,
                      font: {
                        name: 'Trebuchet MS',
                      },
                    }),
                  ],
                }),
                // Separator below the log
                new Paragraph({
                  border: {
                    bottom: { size: 1, color: 'auto', space: 1 },
                  },
                }),
              ])
              .flat(),
          ],
        },
      ],
    });

    const fileName = data.title + ' Logları.doc';

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, fileName);
    });
  }

  const handleProcess = (isHepsijet = false, isDHL = false) => {
    setLoading(true);
    if (
      data.status === '3' &&
      data.apiUserType === 'shopify' &&
      data.isDropOff === '1'
    ) {
      Services.ChangeShopifyPostStatusToWillReturn(token, data.id)
        .then((res) => {
          if (res.data.status) {
            setProcessResult('success');
            setShowResultModal(true);
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          } else {
            setProcessResult('fail');
            setShowResultModal(true);
          }
        })
        .catch((err) => {
          setProcessResult('fail');
          setShowResultModal(true);
        })
        .finally(() => {
          setLoading(false);
          setShowModal(false);
        });
    } else if (data.status === '3' || (isHepsijet && data?.status === '33')) {
      Services.SetInBranch(token, data.id)
        .then((res) => {
          if (res.data.status) {
            setProcessResult('success');
            setShowResultModal(true);
          } else {
            setProcessResult('fail');
            setShowResultModal(true);
          }
        })
        .catch((err) => {
          setProcessResult('fail');
          setShowResultModal(true);
        })
        .finally(() => {
          setShowModal(false);
          setLoading(false);
        });
    } else if (modalAction === 'deliver' || isDHL) {
      const otpType =
        data.deliveryPasswordType === 'hashBased'
          ? 'TrendyolOTP'
          : 'EasypointOTP';
      if (data.apiUserType === 'handsfree' && data.isPaid === '0') {
        Services.SetPaymentStatus(token, data.id, paymentMethod, invoice)
          .then((res) => {
            if (res.data.status) {
              toast.success('Ödeme durumu güncellendi.');
              Services.PostComplete(token, data.barcode, otpType, otp)
                .then((response) => {
                  if (response.data.status) {
                    setProcessResult('success');
                    setShowResultModal(true);
                  } else {
                    if (
                      response.data.message === 'Delivery otp code  not match'
                    ) {
                      toast.error('Teslimat kodu eşleşmiyor.');
                    } else {
                      setProcessResult('fail');
                      setShowResultModal(true);
                    }
                  }
                })
                .catch((error) => {
                  setProcessResult('fail');
                  setShowResultModal(true);
                })
                .finally(() => {
                  setLoading(false);
                  setShowModal(false);
                });
            } else {
              setLoading(false);
              toast.error(
                'Gönderinin ödeme durumu güncellenirken hata oluştu.'
              );
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error('Gönderinin ödeme durumu güncellenirken hata oluştu.');
          });
      } else if (data.apiUserType === 'dhl' && data?.status === '5') {
        Services.PostCompleteForDHL(token, data?.id)
          .then((res) => {
            console.log(res)
            if (res.data.status) {
              setProcessResult('success');
              setShowResultModal(true);
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            } else {
              setProcessResult('fail');
              setShowResultModal(true);
            }
          })
          .catch((err) => {
            console.log(err);
            setProcessResult('fail');
            setShowResultModal(true);
          })
          .finally(() => {
            setLoading(false);
            setShowModal(false);
          });
      } else if (isHepsijet === true && data?.status === '5') {
        if (tc.length !== 11) {
          toast.error('TC No 11 karakter olmalıdır');
          setLoading(false);
          return;
        }

        if (
          hepsijetDeliverName.length < 2 ||
          hepsijetDeliverLastname.length < 2
        ) {
          setLoading(false);
          toast.error('İsim ve soyisim doğru girilmelidir.');
          return;
        }
        Services.PostCompleteByID(token, data?.id, 'tckn', {
          name: hepsijetDeliverName,
          lastname: hepsijetDeliverLastname,
          tckn: tc,
        })
          .then((res) => {
            if (res.data.status) {
              setProcessResult('success');
              setShowResultModal(true);
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            } else {
              setProcessResult('fail');
              setShowResultModal(true);
            }
          })
          .catch((err) => {
            console.log(err);
            setProcessResult('fail');
            setShowResultModal(true);
          })
          .finally(() => {
            setLoading(false);
            setShowModal(false);
          });
      } else {
        Services.PostComplete(token, data.barcode, otpType, otp)
          .then((res) => {
            if (res.data.status) {
              setProcessResult('success');
              setShowResultModal(true);
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            } else {
              if (res.data.message === 'Delivery otp code  not match') {
                toast.error('Teslimat kodu eşleşmiyor.');
              } else {
                setProcessResult('fail');
                setShowResultModal(true);
              }
            }
          })
          .catch((err) => {
            setProcessResult('fail');
            setShowResultModal(true);
          })
          .finally(() => {
            setLoading(false);
            setShowModal(false);
          });
      }
    } else if (modalAction === 'return') {
      if (data.apiUserType === 'shopify') {
        Services.ReturnShopifyPost(token, data.id)
          .then((res) => {
            if (res.data.status) {
              setProcessResult('success');
              setShowResultModal(true);
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            } else {
              setProcessResult('fail');
              setShowResultModal(true);
            }
          })
          .catch((err) => {
            setProcessResult('fail');
            setShowResultModal(true);
          })
          .finally(() => {
            setLoading(false);
            setShowModal(false);
          });
      } else {
        Services.PostReturn(token, data.barcode)
          .then((res) => {
            if (res.data.status) {
              setProcessResult('success');
              setShowResultModal(true);
              setTimeout(() => {
                window.location.reload(true);
              }, 2000);
            } else {
              setProcessResult('fail');
              setShowResultModal(true);
            }
          })
          .catch((err) => {
            setProcessResult('fail');
            setShowResultModal(true);
          })
          .finally(() => {
            setLoading(false);
            setShowModal(false);
          });
      }
    }
  };

  const resendCode = () => {
    if (data.apiUserType === 'aras-kargo') {
      Services.ResendArasKargoOTP(token, data.barcode)
        .then((res) => {
          if (res.data.status) {
            toast.success('Yeni kodunuz gönderilmiştir.');
          } else {
            toast.error('Kod gönderilirken bir oluştu.');
          }
        })
        .catch((err) => {
          toast.error('Kod gönderilirken bir oluştu.');
        });
    } else {
      Services.ResendCode(token, data.id)
        .then((res) => {
          if (res.data.status) {
            setDeliveryCode(res.data.result);
          } else {
            toast.error('Kod gönderilirken bir oluştu.');
          }
        })
        .catch((err) => {
          toast.error('Kod gönderilirken bir oluştu.');
        });
    }
  };

  const deliverWithTC = () => {
    setLoading(true);
    Services.DeliverPostWithTC(parsedUser?.token, data.id, tc)
      .then((res) => {
        if (res.data.status) {
          toast.success('Gönderi başarıyla teslim edilmiştir.');
          setTimeout(() => {
            window.location.reload(true);
          }, 2000);
        } else {
          toast.error('Gönderi teslim edilirken bir hata oluştu.');
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Gönderi teslim edilirken bir hata oluştu.');
      })
      .finally(() => setLoading(false));
  };

  const deliverManually = () => {
    // console.log(parsedUser?.token, data.id);
    setLoading(true);
    Services.DeliverManually(parsedUser?.token, data.id)
      .then((res) => {
        // console.log(res.data);
        if (res.data.status) {
          toast.success('Gönderi başarıyla teslim edilmiştir.');
          setTimeout(() => {
            window.location.reload(true);
          }, 2000);
        } else {
          toast.error('Gönderi teslim edilirken bir hata oluştu.');
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Gönderi teslim edilirken bir hata oluştu.');
      })
      .finally(() => setLoading(false));
  };

  const handleSupportRequest = () => {
    const _description = `<br> <b>Sorun: </b>${supportReadyDescription}${supportDescription?.length > 0
      ? `<br><b>Ek Açıklama: </b> ${supportDescription}`
      : ''
      }`;

    Services.CreateTicketForPostDetail(token, supportTitle, _description)
      .then((res) => {
        if (res.data.status) {
          toast.success('Talep başarıyla oluşturuldu.');
          setSupportTitle('');
          setSupportDescription('');
          setShowSupportDialog(false);
        } else {
          toast.error('Talep oluşturulurken hata oluştu.');
        }
      })
      .catch((err) => {
        toast.error('Talep oluşturulurken hata oluştu.');
      });
  };

  const handleCancel = () => {
    setLoading(true);
    Services.PostCancel(token, data.id)
      .then((res) => {
        if (res.data.status) {
          toast.success('Gönderi başarıyla iptal edilmiştir.');
          setTimeout(() => {
            window.location.reload(true);
          }, 2000);
        } else {
          toast.error('Gönderi iptal edilirken bir hata oluştu.');
        }
      })
      .catch((err) => {
        toast.error('Gönderi iptal edilirken bir hata oluştu.');
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      });
  };

  const handleOpenModal = (action) => {
    if (data.apiUserType === 'aras-kargo') {
      setOpenArasKargoModal(true);
      setModalAction(action);
    } else if (data.apiUserType === 'dhl') {
      handleProcess(false, true);
      setModalAction(action);
    } else {
      setModalAction(action);
      setShowModal(true);
    }
  };

  const handleSetInBranch = () => {
    setOpenSetInBranchModal(true);
  };

  const handleCompleteSetInBranch = () => {
    setLoading(true);
    Services.SetInBranchFromOnPorter(token, data.barcode)
      .then((res) => {
        if (res.data.status) {
          toast.success(
            `"${data.barcode}" numaralı işlem başarıyla zimmete alınmıştır.`
          );
          setLoading(false);
          getPostByBarcode();
          setOpenSetInBranchModal(false);
        } else {
          setLoading(false);
          toast.error(
            `"${data.barcode}" numaralı işlem zimmete alınırken bir sorunla karşılaşıldı.`
          );
        }
      })
      .catch((err) => {
        toast.error(
          `"${data.barcode}" numaralı işlem zimmete alınırken bir sorunla karşılaşıldı.`
        );
        setLoading(false);
      });
  };

  const getStatusLabel = (statusValue) => {
    const status = StatusList.find((item) => item.id === +statusValue);
    return status ? status.label : '';
  };

  const formatDate = (date) => {
    const formattedDate = moment.unix(date).format('DD.MM.YYYY - HH:mm');
    return formattedDate;
  };

  const handlePrintClick = () => {
    const documentDefinition = {
      content: [
        {
          text: moment().format('DD.MM.YYYY, HH:mm'),
          fontSize: 8,
          alignment: 'right',
          margin: [0, 0, 10, 0],
        },
        {
          table: {
            headerRows: 1,
            widths: ['20%', '80%'],
            body: [
              ['Alıcı:', data.willTakenBy],
              [
                'Kargo Firması:',
                (data.status === '9' || data.status === '21') &&
                  data.returnCargoFirm
                  ? data.returnCargoFirm
                  : data.shipmentFirm,
              ],
              ['Gönderen:', data.apiUserType],
              ['Kargo Çıkış Tarihi:', formatDate(data.returnDateTime)],
              [
                'İade Barkod No:',
                data.returnDeliveryCode
                  ? data.returnDeliveryCode
                  : data.barcode,
              ],
            ],
          },
        },
        {
          qr: data.returnDeliveryCode ? data.returnDeliveryCode : data.barcode,
          margin: [0, 10, 0, 0],
        },
      ],
    };

    pdfMake.createPdf(documentDefinition).print();
  };

  const handleReturn = () => {
    closeArasKargoDialog();
    setLoading(true);

    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const token = parsedUser.token;
    if (data.apiUserType === 'aras-kargo') {
      Services.ReturnArasKargoPost(token, data.id)
        .then((res) => {
          if (res.data.status) {
            toast.success(
              `"${data.barcode}" numaralı işlem başarıyla iade edilmiştir.`
            );
            setLoading(false);
            getPostByBarcode();
          } else {
            setLoading(false);
            toast.error(
              `"${data.barcode}" numaralı işlem iade edilirken bir sorunla karşılaşıldı.`
            );
          }
        })
        .catch((err) => {
          toast.error(
            `"${selectedPost.barcode}" numaralı işlem iade edilirken bir sorunla karşılaşıldı.`
          );
          setLoading(false);
        });
    }
  };

  const getPostByBarcode = () => {
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    setUser(parsedUser);
    if (
      (parsedUser?.type === 'user' &&
        parsedUser?.frontAuth?.includes('manager')) ||
      parsedUser?.type === 'superadmin' ||
      parsedUser?.type === 'highadmin'
    ) {
      setPermission(true);
    }
    setToken(parsedUser.token);
    Services.GetPostByOnlyBarcode(parsedUser.token, id)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result[0].apiUserType === 'aras-kargo') {
          Services.GetArasKargoEcommerceCompanyList(parsedUser.token)
            .then((result) => {
              if (result.data.status) {
                let selectedEcommerceCompany = result.data.result.find(
                  (x) => x.id === res.data.result[0].dataJSON.AccountId
                );
                setECommerceCompany(selectedEcommerceCompany.title);
              } else {
                toast.error(
                  'E-Ticaret Firmasının ismi görüntülenirken bir hata meydana geldi.'
                );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }

        setData(res.data.result[0]);
        setArasKargoDeliverName(
          splitName(res.data.result[0].willTakenBy).name[0] + '***'
        );
        setArasKargoDeliverLastname(
          splitName(res.data.result[0].willTakenBy).lastname
            ? splitName(res.data.result[0].willTakenBy).lastname[0] + '***'
            : splitName(res.data.result[0].willTakenBy).lastname
        );
        setDeliveryCode(res.data.result[0].deliveryPassword);
        api
          .post('flow/get-post-logs', { barcode: res.data.result[0].barcode })
          .then((response) => {
            setLogs(response.data.result);
          })
          .catch((error) => {
            console.log(error);
          });
        if (
          res.data.result[0].apiUserType === 'handsfree' &&
          res.data.result[0].status === '5' &&
          res.data.result[0].isPaid === '0'
        ) {
          Services.GetPaymentTypes()
            .then((response) => {
              setPaymentTypes(response.data.result);
            })
            .catch((error) => {
              toast.error('Ödeme türleri alınırken bir hata oluştu.');
            });
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getPostByBarcode();
  }, [id]);

  const handleLogClick = (log) => {
    setSelectedLog(log);
    setShowLogDialog(true);
  };

  const closeLogDialog = () => {
    setSelectedLog(null);
    setShowLogDialog(false);
  };

  const closeArasKargoDialog = () => {
    setOpenArasKargoModal(false);
    setArasKargoDeliverOTP('');
    getPostByBarcode();
  };

  const completeArasKargoDeliver = () => {
    setLoading(true);
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const token = parsedUser.token;
    const customerNameLastname = data.willTakenBy;
    Services.ArasKargoPostComplete(
      token,
      data.barcode,
      customerNameLastname,
      arasKargoDeliverOTP
    )
      .then((response) => {
        if (response.data.status) {
          closeArasKargoDialog();
          toast.success('Gönderi teslim edilmiştir.');
        } else {
          toast.error(
            response.data.message
              ? response.data.message
              : 'Gönderi teslim başarısız.'
          );
        }
      })
      .catch((error) => {
        toast.error('Gönderi teslim edilirken bir hata oluştu.');
      })
      .finally(() => setLoading(false));
  };

  const handleChangeStatus = async () => {
    setIsConfirmModalOpen(false);
    setLoading(true);
    try {
      const payload = { barcodes: [data.barcode] };
      const response = await Services.ChangeCancelOrderStatus(payload);
      if (response.data.status && response.data.result[data.barcode] === true) {
        setProcessResult('success');
        setShowResultModal(true);
        setTimeout(() => {
          window.location.reload(true);
        }, 2000);
      } else {
        setProcessResult('fail');
        setShowResultModal(true);
        toast.error(response.data.message || 'Statü değiştirilirken bir hata oluştu.');
      }
    } catch (error) {
      console.error("Statü değiştirme hatası:", error);
      setProcessResult('fail');
      setShowResultModal(true)
      toast.error('Statü değiştirilirken bir sunucu hatası oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title> Gönderi Detay | Easy Point Panel </title>
      </Helmet>

      {data === null ? (
        <div
          style={{
            height: 500,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <p style={{ textAlign: 'center', fontWeight: 600 }}>Bekleniyor...</p>{' '}
          <CircularProgress />
        </div>
      ) : (
        <div
          className="detail"
          style={{ maxWidth: '1200px', margin: '0 auto' }}
        >
          <Container style={{ marginBottom: 30 }}>
            {(data.status === '9' ||
              data.status === '21' ||
              (data.status === '5' && data.isDropOff === '1')) && (
                <div
                  onClick={handlePrintClick}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginBlock: 15,
                    cursor: 'pointer',
                  }}
                >
                  <Print fontSize="large" />
                </div>
              )}

            <Grid container spacing={2}>
              <Grid item xs={12} sm={7}>
                <div
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    paddingBottom: '29px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <div
                    style={{
                      minHeight: '50px',
                      width: '100%',
                      backgroundColor: '#DC423CE5',
                      borderTopRightRadius: '8px',
                      borderTopLeftRadius: '8px',
                      padding: '10px',
                      marginBottom: '15.5px',
                    }}
                  >
                    <span
                      style={{
                        color: '#F3F4F6',
                        fontWeight: '600',
                        fontSize: '12px',
                      }}
                    >
                      {data.title}
                    </span>
                  </div>
                  <div className="customRow">
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: '400',
                        color: '#8890A0',
                      }}
                    >
                      ID:
                    </Typography>
                    <Typography style={{ color: '#111827', fontSize: 14 }}>
                      {data.id}
                    </Typography>
                  </div>
                  <div className="divider" />
                  <div className="customRow">
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: '400',
                        color: '#8890A0',
                      }}
                    >
                      Barkod:
                    </Typography>
                    <Typography style={{ color: '#111827', fontSize: 14 }}>
                      {data.barcode}
                    </Typography>
                  </div>
                  <div className="divider" />
                  {eCommerceCompany && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Gönderi E-Ticaret Firması:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {eCommerceCompany}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.shipmentNo && (
                    <>
                      {' '}
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Kargo Takip No:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {data.shipmentNo}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  <div className="customRow">
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: '400',
                        color: '#8890A0',
                      }}
                    >
                      Kargo Türü:
                    </Typography>
                    <Typography style={{ color: '#111827', fontSize: 14 }}>
                      Paket {data.isDropOff === '1' && '(İade Gönderisidir)'}
                    </Typography>
                  </div>
                  <div className="divider" />
                  {data.takenName && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Gönderen:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {parsedUser.type === 'esnaf'
                            ? maskName(data.takenName)
                            : data.takenName}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.willTakenBy !== ' ' && (
                    <>
                      {' '}
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Alıcı:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {parsedUser.type === 'esnaf'
                            ? maskName(data.willTakenBy)
                            : data.willTakenBy}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.phone !== false &&
                    data.phone !== null &&
                    parsedUser.type !== 'esnaf' && (
                      <>
                        {' '}
                        <div className="customRow">
                          <Typography
                            style={{
                              fontSize: 14,
                              fontWeight: '400',
                              color: '#8890A0',
                            }}
                          >
                            Alıcı Telefon No:
                          </Typography>
                          <Typography
                            style={{ color: '#111827', fontSize: 14 }}
                          >
                            {data.phone?.slice(0, -7) + '*******'}
                          </Typography>
                        </div>
                        <div className="divider" />
                      </>
                    )}
                  {data.apiUserType !== 'handsfree' && (
                    <>
                      {data.sentToCity && (
                        <>
                          <div className="customRow">
                            <Typography
                              style={{
                                fontSize: 14,
                                fontWeight: '400',
                                color: '#8890A0',
                              }}
                            >
                              Teslim Edilecek İl:
                            </Typography>
                            <Typography
                              style={{ color: '#111827', fontSize: 14 }}
                            >
                              {data.sentToCity}
                            </Typography>
                          </div>
                          <div className="divider" />
                          <div className="customRow">
                            <Typography
                              style={{
                                fontSize: 14,
                                fontWeight: '400',
                                color: '#8890A0',
                              }}
                            >
                              Teslim Edilecek İlçe:
                            </Typography>
                            <Typography
                              style={{ color: '#111827', fontSize: 14 }}
                            >
                              {data.sentToRegion}
                            </Typography>
                          </div>
                          <div className="divider" />
                        </>
                      )}
                    </>
                  )}
                  <div className="customRow">
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: '400',
                        color: '#8890A0',
                      }}
                    >
                      Teslim Edilecek Easy Point Noktası:
                    </Typography>
                    <Typography style={{ color: '#111827', fontSize: 14 }}>
                      {data.pointTitle}
                    </Typography>
                  </div>{' '}
                  <div className="divider" />
                  {data.shipmentFirm && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Kargo Firması:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {data.shipmentFirm}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.returnCargoFirm && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          İade Edilecek Kargo Firması:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {data.returnCargoFirm}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.returnDeliveryCode && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          İade Kargo Kodu:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {data.returnDeliveryCode}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.dataJSON.DocumentSerialNumber &&
                    data.apiUserType === 'aras-kargo' && (
                      <>
                        {' '}
                        <div className="customRow">
                          <Typography
                            style={{
                              fontSize: 14,
                              fontWeight: '400',
                              color: '#8890A0',
                            }}
                          >
                            İrsaliye No:
                          </Typography>
                          <Typography
                            style={{ color: '#111827', fontSize: 14 }}
                          >
                            {data.dataJSON.DocumentSerialNumber}
                          </Typography>
                        </div>
                        <div className="divider" />
                      </>
                    )}
                  <div className="customRow">
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: '400',
                        color: '#8890A0',
                      }}
                    >
                      Gönderi Tarihi:
                    </Typography>
                    <Typography style={{ color: '#111827', fontSize: 14 }}>
                      {formatDate(data.createdDateTime)}
                    </Typography>
                  </div>
                  <div className="divider" />
                  {data.status === '1' && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Teslim Tarihi:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {formatDate(data.completedDateTime)}
                        </Typography>
                      </div>
                      <div className="divider" />
                    </>
                  )}
                  {data.status === '1' && (
                    <>
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Teslim Türü:
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {data.deliverType}
                        </Typography>
                      </div>

                      <div className="divider" />
                      <div className="customRow">
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#8890A0',
                          }}
                        >
                          Teslim Değeri
                        </Typography>
                        <Typography style={{ color: '#111827', fontSize: 14 }}>
                          {data.deliverType !== 'TCKN'
                            ? data.deliverValue
                            : 'Detaylar için yöneticinizle iletişime geçiniz.'}
                        </Typography>
                      </div>

                      <div className="divider" />
                    </>
                  )}
                  {data.apiUserType === 'handsfree' &&
                    data.paymentType !== 'mall-pay' && (
                      <>
                        {data.isPaid === '1' && (
                          <>
                            <div className="customRow">
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontWeight: '400',
                                  color: '#8890A0',
                                }}
                              >
                                Ödeme Yöntemi:
                              </Typography>
                              <Typography
                                style={{ color: '#111827', fontSize: 14 }}
                              >
                                {data.paymentType === 'online' && 'Online'}{' '}
                                {data.paymentType === 'cash' && 'Nakit'}{' '}
                                {data.paymentType === 'credit-card' &&
                                  'Kredi kartı'}
                              </Typography>
                            </div>

                            <div className="divider" />
                          </>
                        )}

                        <div className="customRow">
                          <Typography
                            style={{
                              fontSize: 14,
                              fontWeight: '400',
                              color: '#8890A0',
                            }}
                          >
                            Ödeme Durumu:
                          </Typography>
                          <Typography
                            style={{
                              color: data.isPaid === '0' ? 'red' : 'green',
                            }}
                          >
                            {data.isPaid === '0' ? 'Ödenmedi' : 'Ödendi'}
                          </Typography>
                        </div>
                        <div className="divider" />
                        {data.apiUserType === 'handsfree' && (
                          <>
                            <div className="customRow">
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontWeight: '400',
                                  color: '#8890A0',
                                }}
                              >
                                Oluşturan:
                              </Typography>
                              <Typography
                                style={{ color: '#111827', fontSize: 14 }}
                              >
                                {data.additionalNote?.createdBy?.type ===
                                  'store'
                                  ? 'Mağaza'
                                  : 'Müşteri'}
                              </Typography>
                            </div>
                            <div className="divider" />{' '}
                          </>
                        )}
                      </>
                    )}
                  <div className="customRow">
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: '400',
                        color: '#8890A0',
                      }}
                    >
                      Gönderi Durumu:
                    </Typography>

                    <Typography
                      style={{
                        backgroundColor: 'rgb(77 177 88)',
                        color: 'white',
                        padding: 3,
                        borderRadius: 5,
                        paddingInline: 10,
                        fontSize: '14px',
                      }}
                    >
                      {getStatusLabel(data.status)}
                    </Typography>
                  </div>
                  {((data.status === '3' && data.apiUserType !== 'handsfree') ||
                    data.status === '5' ||
                    data.status === '9' ||
                    data.status === '4' ||
                    data?.status === '33') && (
                      <>
                        <div className="divider" />
                        {((data?.status === '9' &&
                          data?.apiUserType !== 'trendyol') ||
                          (data?.status === '3' &&
                            data?.apiUserType === 'trendyol') ||
                          (data?.status === '3' &&
                            data?.apiUserType === 'shopify') ||
                          (data?.status === '3' &&
                            data?.apiUserType === 'kargoist') ||
                          (data?.status === '3' &&
                            data?.apiUserType === 'hepsiburada') ||
                          (data?.status === '4' &&
                            data?.apiUserType !== 'aras-kargo') ||
                          (data?.status === '33' &&
                            data?.apiUserType === 'hepsijet') ||
                          (data?.status === '9' &&
                            data?.apiUserType === 'trendyol' &&
                            !data?.subStatus) ||
                          data?.status === '5') && (
                            <div className="customRow">
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontWeight: '400',
                                  color: '#8890A0',
                                }}
                              >
                                Teslim
                              </Typography>

                              <div
                                style={{
                                  flexDirection: 'row',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <input
                                  style={{
                                    marginBottom: 3,
                                    height: '38px',
                                    border: '1px solid #D1D5DB',
                                  }}
                                  type="text"
                                  placeholder="Barkod"
                                  value={barcode}
                                  onChange={(e) => setBarcode(e.target.value)}
                                />

                                {data?.apiUserType !== 'aras-kargo' &&
                                  (data?.status === '3' ||
                                    (data?.status === '9' &&
                                      data?.apiUserType !== 'trendyol')) && (
                                    <>
                                      <Button
                                        disabled={barcode !== data.barcode}
                                        style={{
                                          backgroundColor:
                                            barcode !== data.barcode
                                              ? 'gray'
                                              : '#DA3831',
                                          border: 'none',
                                          fontWeight: 600,
                                          color: 'white',
                                          marginLeft: 20,
                                          height: '38px',
                                          paddingInline: '15px',
                                        }}
                                        onClick={() => {
                                          if (data.status === '3') {
                                            handleOpenModal('take');
                                          } else if (
                                            data?.status === '9' &&
                                            data?.apiUserType !== 'trendyol'
                                          ) {
                                            handleOpenModal('return');
                                          }
                                        }}
                                      >
                                        {data?.status === '3'
                                          ? 'Teslim Al'
                                          : data?.apiUserType !== 'trendyol'
                                            ? 'İade Et'
                                            : ''}
                                      </Button>
                                    </>
                                  )}

                                {data?.apiUserType === 'aras-kargo' &&
                                  data?.status === '9' && (
                                    <>
                                      <Button
                                        disabled={barcode !== data.barcode}
                                        style={{
                                          backgroundColor:
                                            barcode !== data.barcode
                                              ? 'gray'
                                              : '#DA3831',
                                          border: 'none',
                                          fontWeight: 600,
                                          color: 'white',
                                          marginLeft: 20,
                                          height: '38px',
                                          paddingInline: '15px',
                                        }}
                                        onClick={() => {
                                          if (data.status === '9') {
                                            handleOpenModal('return');
                                          } else {
                                            handleOpenModal('take');
                                          }
                                        }}
                                      >
                                        {data.status === '9'
                                          ? 'İade Et'
                                          : 'Teslim Al'}
                                      </Button>
                                    </>
                                  )}

                                {/* Eğer status '9' ise ve yetkili kullanıcı ise "Teslim Et" işlemi için buton */}
                                {(data.status === '5' ||
                                  (data.status === '9' &&
                                    data.apiUserType !== 'hepsijet' &&
                                    (!data.subStatus || data.subStatus === '35') &&
                                    (user.type === 'superadmin' ||
                                      user.type === 'highadmin' ||
                                      user.type === 'user' ||
                                      user.type === 'esnaf'))) &&
                                  data.isDropOff === '0' && (
                                    <Button
                                      disabled={barcode !== data.barcode || loading}
                                      style={{
                                        backgroundColor:
                                          barcode !== data.barcode
                                            ? 'gray'
                                            : '#DA3831',
                                        border: 'none',
                                        fontWeight: 600,
                                        color: 'white',
                                        marginLeft: 20,
                                        height: '38px',
                                        paddingInline: '15px',
                                      }}
                                      onClick={() => handleOpenModal('deliver')}
                                    >
                                      {loading ? 'Teslim Ediliyor...' : 'Teslim Et'}
                                    </Button>
                                  )}

                                {(data.status === '4' ||
                                  (data.status === '33' &&
                                    data?.apiUserType === 'hepsijet')) && (
                                    <Button
                                      disabled={barcode !== data.barcode}
                                      style={{
                                        backgroundColor:
                                          barcode !== data.barcode
                                            ? 'gray'
                                            : '#DA3831',
                                        border: 'none',
                                        fontWeight: 600,
                                        color: 'white',
                                        marginLeft: 20,
                                        height: '38px',
                                        paddingInline: '15px',
                                      }}
                                      onClick={handleSetInBranch}
                                    >
                                      Zimmete Al
                                    </Button>
                                  )}
                              </div>
                            </div>
                          )}
                      </>
                    )}
                </div>

                {data?.apiUserType === 'hepsiburada' &&
                  data?.isDropOff === '1' &&
                  data?.status === '5' && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginTop: '10px',
                        padding: '5px',
                        border: '1px solid #b38105',
                        borderRadius: '5px',
                        backgroundColor: 'white',
                      }}
                    >
                      <Iconify
                        icon={'mdi:information'}
                        style={{
                          color: '#98A2B3',
                          width: 22,
                          height: 22,
                          display: 'flex',
                          cursor: 'pointer',
                          marginRight: '5px',
                        }}
                      />
                      <Typography>
                        Hepsiburada tarafından kargo firmasının güncellenmesi
                        bekleniyor.
                      </Typography>
                    </div>
                  )}

                {data.apiUserType !== 'aras-kargo' &&
                  !(
                    data.apiUserType === 'trendyol' &&
                    data.status === '9' &&
                    ['34', '36', '37'].includes(data.subStatus)
                  ) &&
                  (data.status === '5' || data.status === '9') &&
                  (user?.type === 'highadmin' ||
                    user.frontAuth?.includes('EP') ||
                    user?.type === 'superadmin' ||
                    (user?.type === 'admin' &&
                      user.frontAuth?.includes('manager'))) && (
                    <>
                      {data.apiUserType !== 'hepsijet' && data.apiUserType !== "dhl" && (
                        <Button
                          style={{
                            backgroundColor: '#DA3831',
                            border: '1px solid #C5342E',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: 'white',
                            marginRight: 25,
                            minWidth: 150,
                            marginTop: 10,
                            height: '44px',
                          }}
                          onClick={() => {
                            setShowTCDialog(true);
                          }}
                        >
                          TC ile Teslim
                        </Button>
                      )}
                      {data.apiUserType !== 'hepsijet' && data.apiUserType !== "dhl" && (
                        <Button
                          style={{
                            backgroundColor: '#DA3831',
                            border: '1px solid #C5342E',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: 'white',
                            marginRight: 25,
                            marginTop: 10,
                            minWidth: 150,
                            height: '44px',
                          }}
                          onClick={() => {
                            setShowManualDialog(true);
                          }}
                        >
                          Manuel Teslim
                        </Button>
                      )}

                      {data.apiUserType === "dhl" && data.status === "5" && (
                        <Button
                          style={{
                            backgroundColor: '#DA3831',
                            border: '1px solid #C5342E',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: 'white',
                            marginRight: 25,
                            marginTop: 10,
                            minWidth: 150,
                            height: '44px',
                          }}
                          onClick={dhlCustomerRefuse}
                        >
                          Müşteri Almayı Reddetti
                        </Button>
                      )}
                    </>
                  )}

                <div style={{ marginTop: '15px' }}>
                  {data.apiUserType === 'trendyol' &&
                    data.status === '9' &&
                    data.subStatus === '34' && (
                      <Typography>
                        {' '}
                        Gönderi kayıp oluğu için teslim edilemez
                      </Typography>
                    )}
                  {data.apiUserType === 'trendyol' &&
                    data.status === '9' &&
                    data.subStatus === '36' && (
                      <Typography>
                        {' '}
                        Gönderi dolandırıcılık sebebiyle teslim edilemez
                      </Typography>
                    )}
                  {data.apiUserType === 'trendyol' &&
                    data.status === '9' &&
                    data.subStatus === '37' && (
                      <Typography>
                        {' '}
                        Gönderi zarar gördüğü için teslim edilemez
                      </Typography>
                    )}
                </div>

                {user.type === 'superadmin' && (
                  <Button
                    style={{
                      backgroundColor: 'orange',
                      border: 'none',
                      fontWeight: 600,
                      color: 'white',
                      minWidth: 150,
                      marginTop: 10,
                    }}
                    onClick={() => {
                      setShowCancelDialog(true);
                    }}
                  >
                    İptal Et
                  </Button>
                )}
              </Grid>

              <Grid item xs={12} sm={5}>
                <div
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    paddingBottom: '29px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  {data.apiUserType === 'dhl' &&
                    data.status === '1' &&
                    !data.dhlCustomerSign && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          mb: 2, // log bölümüne biraz boşluk bırakmak için
                        }}
                      >
                        <img
                          // src={`http://qr.easypointapi.com/?chs=500x500&cht=qr&chl=localhost:3006/dhl-send-sign/${data.barcode}`}
                          src={`http://qr.easypointapi.com/?chs=500x500&cht=qr&chl=panel.easypoint.com.tr/dhl-send-sign/${data.barcode}`}
                          // src={`http://qr.easypointapi.com/?chs=500x500&cht=qr&chl=stage-panel.easypoint.com.tr/dhl-send-sign/${data.barcode}`}
                          alt="DHL İmza QR Kodu"
                          style={{ maxWidth: 200, maxHeight: 200 }}
                        />
                      </Box>
                    )}
                  <div
                    style={{
                      width: '100%',
                      height: '42px',
                      flexDirection: 'row',
                      display: 'flex',
                      backgroundColor: '#DDDFE3',
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '8px',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingRight: '15px',
                      paddingLeft: '22px',
                      marginBottom: '15px',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'center',
                        color: '#DA3831',
                        flex: 1,
                        fontWeight: '400',
                        fontSize: '14px',
                        color: '#6B7280',
                      }}
                    >
                      Gönderi Logları
                    </p>

                    {logs?.length > 0 && (
                      <Iconify
                        icon={'teenyicons:download-outline'}
                        style={{
                          color: '#98A2B3',
                          width: 22,
                          height: 22,
                          cursor: 'pointer',
                          marginLeft: 'auto', // Bu satır sağa dayalı yapar
                        }}
                        onClick={exportToWord}
                      />
                    )}
                  </div>

                  {logs?.length >= 1 ? (
                    logs?.map((log, index) => (
                      <React.Fragment key={log.id}>
                        <div
                          style={{
                            backgroundColor: 'rgba(220, 66, 60, 0.898)',
                            padding: 10,
                            width: '95%',
                            marginLeft: '2.5%',
                            textAlign: 'center',
                            marginBottom: 10,
                            fontSize: '14px',
                            color: '#fff',
                            wordWrap: 'break-word',
                            cursor: permission ? 'pointer' : 'default',
                          }}
                          onClick={() => {
                            if (permission) {
                              handleLogClick(log);
                            } else {
                              return;
                            }
                          }}
                        >
                          {log.view.message ? log.view.message : log.view}
                        </div>
                        {index < logs?.length - 1 && (
                          <div className="divider" />
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <p
                      style={{
                        fontWeight: '500',
                        fontSize: '14px',
                        marginLeft: '18px',
                        color: '#B7B7B7',
                        fontFamily: 'Inter',
                      }}
                    >
                      Log bulunmamaktadır.
                    </p>
                  )}
                </div>
              </Grid>
            </Grid>

            <Stack
              style={{
                marginTop: '20px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Button
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #D0D5DD',
                  fontWeight: 600,
                  fontSize: '14px',
                  color: '#344054',
                  marginRight: 25,
                  minWidth: 150,
                  height: '44px',
                }}
                onClick={() => {
                  setSupportTitle(
                    `${data.barcode} barkodlu ${data.pointTitle} (Point ID: ${data.sentToEasyPoint}) noktasına ait gönderi (Post ID: ${data.id}) konulu yeni bir destek talebi bulunmaktadır.`
                  );
                  setShowSupportDialog(true);
                }}
              >
                Destek Talebi Oluştur
              </Button>
              {
                data.status === '9' && (
                  <>
                    <Button
                      style={{
                        backgroundColor: '#fff',
                        border: '1px solid #D0D5DD',
                        fontWeight: 600,
                        fontSize: '14px',
                        color: '#344054',
                        marginRight: 25,
                        minWidth: 150,
                        height: '44px',
                      }}
                      onClick={() => setIsConfirmModalOpen(true)}
                    >
                      Statü Değiştir
                    </Button>

                    {/* Confirmation Modal */}
                    <Dialog
                      open={isConfirmModalOpen}
                      onClose={() => setIsConfirmModalOpen(false)}
                    >
                      <DialogTitle>Statü Değiştirme Onayı</DialogTitle>
                      <DialogContent>
                        <Typography>
                          Yeni iş emri oluşturma işlemini onaylıyor musunuz?
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => setIsConfirmModalOpen(false)}
                          color="inherit"
                        >
                          İptal
                        </Button>
                        <Button
                          onClick={handleChangeStatus}
                          color="primary"
                          variant="contained"
                          disabled={loading}
                        >
                          {loading ? 'İşleniyor...' : 'Onayla'}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                )
              }
              {data.status === '9' && data.apiUserType === 'hepsijet' && (
                <Typography>
                  *Bu gönderi iadeye döndüğü için müşteriye kesinlikle{' '}
                  <strong style={{ fontSize: 16, color: 'red' }}>
                    teslim edilemez.
                  </strong>
                </Typography>
              )}
            </Stack>
          </Container>

          <Dialog
            open={showModal}
            onClose={() => setShowModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle textAlign={'center'}>
              {modalAction === 'take' && 'Teslim Al'}
              {modalAction === 'deliver' && 'Teslim Et'}
              {modalAction === 'return' && 'İade Et'}
            </DialogTitle>
            <DialogContent>
              {/* Teslim, Zimmete Alma ve İade İçin Ortak ve Özel Alanlar */}
              <div
                style={{
                  marginBlock: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {data.apiUserType === 'handsfree' &&
                  data.isPaid === '0' &&
                  modalAction === 'deliver' && (
                    <>
                      <Typography>
                        Ödeme bilgisi olarak fiş numarasını giriniz.
                      </Typography>
                      <TextField
                        className="mb-2"
                        type="text"
                        style={{
                          height: 50,
                          width: 300,
                          marginTop: 20,
                          marginBottom: 30,
                        }}
                        placeholder="Fiş Numarası"
                        value={invoice}
                        onChange={(e) => setInvoice(e.target.value)}
                      />
                      <FormControl
                        sx={{ m: 1, minWidth: 300, marginBottom: '60px' }}
                      >
                        <Select
                          value={paymentMethod}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          displayEmpty
                          input={<OutlinedInput />}
                        >
                          <MenuItem value="" disabled>
                            Ödeme Yöntemi
                          </MenuItem>
                          {paymentTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                              {type === 'cash' && 'Nakit'}
                              {type === 'credit-card' && 'Kredi Kartı'}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </>
                  )}

                <Typography>
                  {modalAction === 'take' &&
                    'Teslim almak istediğinize emin misiniz?'}
                  {(modalAction === 'deliver' && data.apiUserType !== "hepsijet") &&
                    'Teslim etmek için otp kodunu giriniz.'}
                  {(modalAction === 'deliver' && data.apiUserType === "hepsijet") &&
                    'Teslim etmek için alanları doldurunuz.'}
                  {modalAction === 'return' &&
                    'İade etmek istediğinize emin misiniz?'}
                </Typography>

                {/* OTP Kodu Girme Alanı ve Butonlar */}
                {modalAction === 'deliver' ? (
                  <>
                    {data.apiUserType === 'hepsijet' ? (
                      <>
                        <span
                          style={{
                            width: '100%',
                            justifyContent: 'flex-start',
                            display: 'flex',
                            marginTop: '13px',
                            color: '#6A6A6A',
                            fontSize: '12px',
                            fontFamily: 'Inter',
                            fontWeight: '600',
                          }}
                        >
                          Adınız
                        </span>
                        <TextField
                          placeholder="Adınızı Giriniz"
                          variant="outlined"
                          value={hepsijetDeliverName}
                          onChange={(e) =>
                            setHepsijetDeliverName(e.target.value)
                          }
                          sx={{ mt: 2, width: '100%' }}
                        />

                        <span
                          style={{
                            width: '100%',
                            justifyContent: 'flex-start',
                            display: 'flex',
                            marginTop: '13px',
                            color: '#6A6A6A',
                            fontSize: '12px',
                            fontFamily: 'Inter',
                            fontWeight: '600',
                          }}
                        >
                          Soyadınız
                        </span>
                        <TextField
                          placeholder="Soyadınızı Giriniz"
                          variant="outlined"
                          value={hepsijetDeliverLastname}
                          onChange={(e) =>
                            setHepsijetDeliverLastname(e.target.value)
                          }
                          sx={{ mt: 2, width: '100%' }}
                        />
                        <span
                          style={{
                            width: '100%',
                            justifyContent: 'flex-start',
                            display: 'flex',
                            marginTop: '13px',
                            color: '#6A6A6A',
                            fontSize: '12px',
                            fontFamily: 'Inter',
                            fontWeight: '600',
                          }}
                        >
                          TC
                        </span>
                        <TextField
                          className="mb-2"
                          type="text"
                          sx={{ mt: 2, width: '100%' }}
                          placeholder="TC No"
                          value={tc}
                          inputProps={{ maxLength: 11 }}
                          onChange={(e) => setTc(e.target.value)}
                        />
                        <Button
                          disabled={loading}
                          onClick={() => handleProcess(true)}
                          sx={{
                            width: '100%',
                            backgroundColor: '#DC423C',
                            color: 'white',
                            marginTop: '21px',
                            height: '54px',
                            display: 'flex',
                            '&:hover': {
                              backgroundColor: '#B53832',
                            },
                            '&.Mui-disabled': {
                              backgroundColor: '#DDDFE3',
                            },
                          }}
                          fullWidth
                        >
                          {loading ? 'Teslim Ediliyor...' : 'Teslim Et'}
                        </Button>
                        <Button
                          onClick={() => setShowModal(false)}
                          sx={{
                            width: '100%',
                            backgroundColor: '#fff',
                            border: '1px solid #DC423C',
                            color: '#DC423C',
                            marginTop: '21px',
                            height: '54px',
                            display: 'flex',

                            '&.Mui-disabled': {
                              backgroundColor: '#DDDFE3',
                            },
                          }}
                          fullWidth
                        >
                          Vazgeç
                        </Button>
                      </>
                    ) : (
                      <div
                        style={{
                          width: '100%',
                          marginTop: 20,
                          alignItems: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <TextField
                          className="mb-2"
                          type="text"
                          style={{ height: 50, width: 300 }}
                          placeholder="Kod"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                        />
                        <Button
                          disabled={loading}
                          onClick={handleProcess}
                          style={{
                            paddingBlock: 5,
                            paddingInline: 20,
                            borderRadius: 5,
                            border: 'none',
                            backgroundColor: loading ? 'gray' : 'green',
                            color: 'white',
                            fontWeight: '600',
                            marginTop: 20,
                          }}
                        >
                          {loading ? 'Teslim Ediliyor...' : 'Teslim Et'}
                        </Button>

                        {data.apiUserType !== 'handsfree' && (
                          <Button
                            variant="text"
                            onClick={resendCode}
                            style={{
                              paddingBlock: 5,
                              paddingInline: 20,
                              borderRadius: 5,
                              color: 'blue',
                              fontWeight: '600',
                              marginTop: 20,
                            }}
                          >
                            Tekrar Kod Gönder
                          </Button>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex">
                    <Button
                      onClick={handleProcess}
                      disabled={loading}
                      style={{
                        paddingBlock: 5,
                        paddingInline: 20,
                        borderRadius: 5,
                        border: 'none',
                        backgroundColor: 'green',
                        color: 'white',
                        fontWeight: '600',
                        marginTop: 20,
                        marginRight: 50,
                      }}
                    >
                      {loading ? 'Gerçekleştiriliyor...' : 'Evet'}
                    </Button>
                    <Button
                      onClick={() => setShowModal(false)}
                      style={{
                        paddingBlock: 5,
                        paddingInline: 20,
                        borderRadius: 5,
                        border: 'none',
                        backgroundColor: 'red',
                        color: 'white',
                        fontWeight: '600',
                        marginTop: 20,
                      }}
                    >
                      Hayır
                    </Button>
                  </div>
                )}
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={showResultModal}
            onClose={() => setShowResultModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle style={{ textAlign: 'center', width: '100%' }}>
              {processResult === 'success' ? 'Başarılı' : 'Hata'}
            </DialogTitle>
            <DialogContent>
              <div
                style={{
                  marginBlock: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography>
                  {processResult === 'success'
                    ? 'İşleminiz başarıyla gerçekleştirilmiştir.'
                    : 'İşleminiz gerçekleştirilirken bir hata meydana geldi.'}
                </Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  window.location.reload();
                  setShowResultModal(false);
                  setShowModal(false);
                }}
              >
                Kapat
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={showSupportDialog}
            onClose={() => setShowSupportDialog(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Destek Talebi Oluştur</DialogTitle>
            <DialogContent>
              <div>
                <TextField
                  fullWidth
                  disabled
                  label="Destek Talebi Başlığı"
                  value={supportTitle}
                  onChange={(e) => setSupportTitle(e.target.value)}
                  sx={{ marginBlock: 2 }}
                />

                <Select
                  sx={{ minWidth: '350px', marginBottom: 2 }}
                  displayEmpty
                  value={supportReadyDescription}
                  input={<OutlinedInput />}
                  onChange={(e) => setSupportReadyDescription(e.target.value)}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>Talep konusu</em>;
                    }

                    return selected;
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {readyList.map((x, index) => (
                    <MenuItem key={index} value={x}>
                      {x}
                    </MenuItem>
                  ))}
                </Select>

                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Destek Talebi Açıklaması"
                  value={supportDescription}
                  onChange={(e) => setSupportDescription(e.target.value)}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSupportRequest} color="primary">
                Talebi Oluştur
              </Button>

              <Button
                onClick={() => setShowSupportDialog(false)}
                color="primary"
              >
                İptal
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={showCancelDialog}
            onClose={() => setShowCancelDialog(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>İptal Et</DialogTitle>
            <DialogContent>
              <div
                style={{
                  marginBlock: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography>İptal etmek istediğinize emin misiniz?</Typography>

                <div className="d-flex">
                  <Button
                    onClick={handleCancel}
                    disabled={loading}
                    style={{
                      paddingBlock: 5,
                      paddingInline: 20,
                      borderRadius: 5,
                      border: 'none',
                      backgroundColor: loading ? 'gray' : 'green',
                      color: 'white',
                      fontWeight: '600',
                      marginTop: 20,
                      marginRight: 50,
                    }}
                  >
                    {loading ? 'Gerçekleştiriliyor...' : 'Evet'}
                  </Button>
                  <Button
                    onClick={() => setShowCancelDialog(false)}
                    style={{
                      paddingBlock: 5,
                      paddingInline: 20,
                      borderRadius: 5,
                      border: 'none',
                      backgroundColor: 'red',
                      color: 'white',
                      fontWeight: '600',
                      marginTop: 20,
                    }}
                  >
                    Hayır
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={showTCDialog}
            onClose={() => setShowTCDialog(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>TC ile Teslim Et</DialogTitle>
            <DialogContent>
              <div
                style={{
                  marginBlock: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <TextField
                  className="mb-2"
                  type="text"
                  style={{ height: 50, width: 300 }}
                  placeholder="TC No"
                  value={tc}
                  inputProps={{ maxLength: 11 }}
                  onChange={(e) => setTc(e.target.value)}
                />
                <div className="d-flex">
                  <Button
                    onClick={deliverWithTC}
                    disabled={loading || tc?.length !== 11}
                    style={{
                      paddingBlock: 5,
                      paddingInline: 20,
                      borderRadius: 5,
                      border: 'none',
                      backgroundColor:
                        loading || tc?.length !== 11 ? 'gray' : 'green',
                      color: 'white',
                      fontWeight: '600',
                      marginTop: 20,
                      marginRight: 50,
                    }}
                  >
                    {loading ? 'Teslim Ediliyor...' : 'Teslim Et'}
                  </Button>
                  <Button
                    onClick={() => setShowTCDialog(false)}
                    style={{
                      paddingBlock: 5,
                      paddingInline: 20,
                      borderRadius: 5,
                      border: 'none',
                      backgroundColor: 'red',
                      color: 'white',
                      fontWeight: '600',
                      marginTop: 20,
                    }}
                  >
                    Kapat
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={showManualDialog}
            onClose={() => setShowManualDialog(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Manuel Teslim</DialogTitle>
            <DialogContent>
              <div
                style={{
                  marginBlock: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography>
                  Manuel olarak teslim etmek istediğinize emin misiniz?
                </Typography>

                <div className="d-flex">
                  <Button
                    onClick={deliverManually}
                    disabled={loading}
                    style={{
                      paddingBlock: 5,
                      paddingInline: 20,
                      borderRadius: 5,
                      border: 'none',
                      backgroundColor: loading ? 'gray' : 'green',
                      color: 'white',
                      fontWeight: '600',
                      marginTop: 20,
                      marginRight: 50,
                    }}
                  >
                    {loading ? 'Teslim Ediliyor...' : 'Teslim Et'}
                  </Button>
                  <Button
                    onClick={() => setShowManualDialog(false)}
                    style={{
                      paddingBlock: 5,
                      paddingInline: 20,
                      borderRadius: 5,
                      border: 'none',
                      backgroundColor: 'red',
                      color: 'white',
                      fontWeight: '600',
                      marginTop: 20,
                    }}
                  >
                    Kapat
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>

          {/* Log Dialog */}
          <Dialog
            open={showLogDialog}
            onClose={closeLogDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Log Detayları</DialogTitle>
            <DialogContent>
              {selectedLog && (
                <>
                  <Typography>
                    <strong>ID:</strong> {selectedLog.id}
                  </Typography>
                  <Typography>
                    <strong>Aksiyon:</strong> {selectedLog.action}
                  </Typography>
                  {selectedLog.status && selectedLog.status !== '' && (
                    <Typography>
                      <strong>Durum:</strong>{' '}
                      {getStatusLabel(selectedLog.status)}
                    </Typography>
                  )}
                  <Typography>
                    <strong>Oluşturulma Tarihi:</strong>{' '}
                    {formatDate(selectedLog.created_date_time)}
                  </Typography>
                  <Typography>
                    <strong>Log:</strong>{' '}
                    {selectedLog.view.message
                      ? selectedLog.view.message
                      : selectedLog.view}
                  </Typography>
                  <Typography>
                    <strong>Kullanıcı Tipi:</strong> {selectedLog.user_type}
                  </Typography>
                  <Typography>
                    <strong>Oluşturan Kullanıcı ID:</strong>{' '}
                    {selectedLog.created_by}
                  </Typography>
                  <Typography>
                    <strong>Kullanıcı IP:</strong> {selectedLog.created_ip}
                  </Typography>
                </>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={closeLogDialog} color="primary">
                Kapat
              </Button>
            </DialogActions>
          </Dialog>

          {/* Aras Kargo Modal */}

          <Modal
            open={openArasKargoModal && modalAction !== 'return'}
            onClose={closeArasKargoDialog}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                maxWidth: 'sm',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: '8px',
              }}
            >
              <Typography
                sx={{
                  color: '#3B3B3B',
                  fontSize: '16px',
                  fontWeight: '600',
                  fontFamily: 'Inter',
                }}
              >
                Teslim Et
              </Typography>

              <span
                style={{
                  width: '100%',
                  justifyContent: 'flex-start',
                  display: 'flex',
                  marginTop: '13px',
                  color: '#6A6A6A',
                  fontSize: '12px',
                  fontFamily: 'Inter',
                  fontWeight: '600',
                }}
              >
                Adınız
              </span>
              <TextField
                placeholder="Adınızı Giriniz"
                variant="outlined"
                disabled
                value={arasKargoDeliverName}
                sx={{ mt: 2, width: '100%' }}
              />

              <span
                style={{
                  width: '100%',
                  justifyContent: 'flex-start',
                  display: 'flex',
                  marginTop: '13px',
                  color: '#6A6A6A',
                  fontSize: '12px',
                  fontFamily: 'Inter',
                  fontWeight: '600',
                }}
              >
                Soyadınız
              </span>
              <TextField
                placeholder="Soyadınızı Giriniz"
                variant="outlined"
                disabled
                value={arasKargoDeliverLastname}
                sx={{ mt: 2, width: '100%' }}
              />

              <span
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  display: 'flex',
                  marginTop: '28px',
                  color: '#6A6A6A',
                  fontSize: '12px',
                  fontFamily: 'Inter',
                  fontWeight: '400',
                }}
              >
                Teslim etmek için OTP kodunu giriniz.
              </span>
              <TextField
                placeholder="OTP kodunuz"
                variant="outlined"
                value={arasKargoDeliverOTP}
                onChange={(e) => setArasKargoDeliverOTP(e.target.value)}
                sx={{ mt: 2, width: '100%' }}
              />
              <span
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  display: 'flex',
                  marginTop: '9px',
                  color: '#A9A9A9',
                  fontSize: '10px',
                  fontFamily: 'Inter',
                  fontWeight: '400',
                }}
              >
                Lütfen telefonunuza gelen kodu giriniz.
              </span>
              <Button
                disabled={loading}
                onClick={completeArasKargoDeliver}
                sx={{
                  mt: 3,
                  width: '150px',
                  height: '36px',
                  backgroundColor: loading ? 'gray' : '#079455',
                  borderRadius: '5px',
                  color: '#fff',
                  fontSize: '14px',
                  fontWeight: '400',
                  lineHeight: '26px',
                  '&:hover': {
                    backgroundColor: loading ? 'gray' : '#067544',
                    cursor: loading ? 'default' : 'pointer',
                  },
                }}
              >
                {loading ? 'Teslim Ediliyor...' : 'Teslim Et'}
              </Button>
              <span
                onClick={resendCode}
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  display: 'flex',
                  marginTop: '28px',
                  color: '#6A6A6A',
                  fontSize: '12px',
                  fontFamily: 'Inter',
                  fontWeight: '400',
                  cursor: 'pointer',
                }}
              >
                Tekrar Kod Gönder
              </span>
            </Box>
          </Modal>

          <Modal
            open={openArasKargoModal && modalAction === 'return'}
            onClose={closeArasKargoDialog}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: '8px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                id="modal-modal-description"
                sx={{ mt: 1, fontSize: '15px', textAlign: 'left' }}
              >
                <b>"{data?.id}"</b> numaralı Aras kargo gönderisini iade etmek
                istiyor musunuz?
              </Typography>
              <Button
                onClick={handleReturn}
                sx={{
                  width: '100%',
                  backgroundColor: '#DC423C',
                  color: 'white',
                  marginTop: '21px',
                  height: '54px',
                  display: 'flex',
                  '&:hover': {
                    backgroundColor: '#B53832',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#DDDFE3',
                  },
                }}
                fullWidth
              >
                İade İşlemini Onayla
              </Button>
              <Button
                onClick={closeArasKargoDialog}
                sx={{
                  width: '100%',
                  backgroundColor: '#fff',
                  border: '1px solid #DC423C',
                  color: '#DC423C',
                  marginTop: '21px',
                  height: '54px',
                  display: 'flex',

                  '&.Mui-disabled': {
                    backgroundColor: '#DDDFE3',
                  },
                }}
                fullWidth
              >
                Vazgeç
              </Button>
            </Box>
          </Modal>

          {/* Zimmete Al Modal */}

          <Modal
            open={openSetInBranchModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: '8px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                id="modal-modal-description"
                sx={{ mt: 1, fontSize: '15px', textAlign: 'left' }}
              >
                Zimmete almak istediğinize emin misiniz?
              </Typography>
              <Button
                disabled={loading}
                onClick={() =>
                  data?.apiUserType === 'hepsijet'
                    ? handleProcess(true)
                    : handleCompleteSetInBranch()
                }
                sx={{
                  width: '100%',
                  backgroundColor: '#DC423C',
                  color: 'white',
                  marginTop: '21px',
                  height: '54px',
                  display: 'flex',
                  '&:hover': {
                    backgroundColor: '#B53832',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#DDDFE3',
                  },
                }}
                fullWidth
              >
                Zimmete Al
              </Button>
              <Button
                disabled={loading}
                onClick={() => setOpenSetInBranchModal(false)}
                sx={{
                  width: '100%',
                  backgroundColor: '#fff',
                  border: '1px solid #DC423C',
                  color: '#DC423C',
                  marginTop: '21px',
                  height: '54px',
                  display: 'flex',

                  '&.Mui-disabled': {
                    backgroundColor: '#DDDFE3',
                  },
                }}
                fullWidth
              >
                Vazgeç
              </Button>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
}
